import { TYPES_SIGNIN } from 'components/TargetedOffers/constants';
import { getTargetedOffersQuery } from './getTargetedOffersQuery';
import { fetchTargetedOffers } from '../loadTargetedOffers';

export const retryTargetedOffersSignIn = async ({
  updateState,
  globalization,
  initialState,
  apolloClient,
  query,
  toogles,
  targetedOffersLoading,
  removeFromQualifiersSelecting,
  applyFilters,
  targetedOffersQuery,
  config,
}) => {
  const [typeEmail, typeLoyalty] = TYPES_SIGNIN;
  const { query: querybase } = getTargetedOffersQuery(targetedOffersQuery);
  const { TypeSignIn } = targetedOffersQuery || {};

  if (TypeSignIn == typeLoyalty || TypeSignIn == typeEmail) {
    const request = {
      updateState,
      inputData: querybase,
      globalization,
      initialState,
      apolloClient,
      query,
      toogles,
      targetedOffersLoading,
      removeFromQualifiersSelecting,
      applyFilters,
      config,
    };

    fetchTargetedOffers(request);
  }
};
